var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52516 15.6357V8.84438L16.0116 12.251L9.52516 15.6357ZM23.7609 7.66751C23.6473 6.8008 23.3192 5.9761 22.8064 5.26813C22.172 4.62159 21.3068 4.25339 20.4009 4.2445C17.0409 4 12.0055 4 12.0055 4H11.9945C11.9945 4 6.95544 4 3.59909 4.2445C2.69327 4.25359 1.82812 4.62176 1.19363 5.26813C0.681304 5.97621 0.353837 6.80093 0.24092 7.66751C0.0911928 8.96631 0.0107677 10.2721 0 11.5795V13.4132C0.0107332 14.7206 0.0911583 16.0265 0.24092 17.3252C0.353837 18.1918 0.681304 19.0166 1.19363 19.7246C1.92265 20.3773 2.8633 20.7441 3.84182 20.7573C5.76182 20.9398 12.0036 21 12.0036 21C12.0036 21 17.0482 21 20.3991 20.7482C21.3048 20.7387 22.1698 20.3707 22.8046 19.7246C23.3174 19.0167 23.6455 18.192 23.7591 17.3252C23.9089 16.0265 23.9893 14.7206 24 13.4132V11.5795C23.9892 10.2721 23.9088 8.96631 23.7591 7.66751H23.7609Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.b7b43a04d8ec479074fc6af5731ad7b1.svg";
export { ForwardRef as ReactComponent };